export default {
  basicViewItem: [{
    prop: 'status',
    label: '',
    Object: 'value'
  }, {
    prop: 'supplier',
    label: '',
    Object: 'value'
  }, {
    prop: 'created_at',
    label: '',
    Object: 'value'
  }]
}
